
import React, {  useState } from 'react'
import Layout from "../../components/Layout/Layout";
import { Link } from "react-router-dom";
import { SearchIcon } from '@heroicons/react/solid';
import { DocumentDownloadIcon, DotsHorizontalIcon} from "@heroicons/react/outline";

const people = [
    {
        accounNo: '0928339309',
        cardName: 'Adebimpe Tayo',
        accounOfficer: 'Ola Akpan',
        branch: 'Lagos',
        cardType: 'Debit',
        date: '22-Mar-1890',
        status: 'Issued'
    },
    {
        accounNo: '0928339309',
        cardName: 'Adebimpe Tayo',
        accounOfficer: 'Ola Akpan',
        branch: 'Abuja',
        cardType: 'Credit',
        date: '12-Mar-1890',
        status: 'Not Found'
    },
    // More people...
]

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}


export default function ActiveCards() {
   

    const exportCSV  = async () => {

    }
  
    return (<>
        <Layout title={'Active Debit Cards'} pageTag={'cards'} current={'/active/card'}>
            <React.Fragment>
                <main>
                    <div className='max-w-7xl mx-auto px-4 sm:px-6 md:px-8'>
                        <div className="px-4 sm:px-6 lg:px-8">
                            <div className="sm:flex sm:items-center">
                                <div className="sm:flex-auto flex">
                                    <div className="mt-1 relative rounded-md shadow-sm">
                                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                            <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                        </div>
                                        <input
                                            type="text"
                                            name="user"
                                            id="user"
                                            className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                                            placeholder="Search customer"
                                        />
                                    </div>
                                    <div className="mt-1 relative rounded-md shadow-sm ml-3">
                                        <select
                                            id="currency"
                                            name="currency"
                                            placeholder="Sort by"
                                            className="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2 pr-7 border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md"
                                        >
                                            <option>Sort by</option>
                                            <option>All</option>
                                            <option>Name</option>
                                            <option>Department</option>
                                            <option>Role</option>
                                        </select>

                                    </div>
                                </div>

                                <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
                                    <button
                                        type="button"
                                        onClick={exportCSV}
                                        className="inline-flex hover:text-white active:text-white mr-2 items-center justify-center rounded-md border border-transparent btn-green px-2 py-2 text-sm font-medium text-green shadow-sm sm:w-auto"
                                    >
                                        <DocumentDownloadIcon className="w-4 mr-1.5" />
                                        Export CSV
                                    </button>
                                    {/* <Link to="/create/user">
                                        <button
                                            type="button"
                                            className="inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-2 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                                        >
                                            <PlusCircleIcon className="w-4 mr-1.5" />
                                            Add Mailing Beneficiary
                                        </button>
                                    </Link> */}
                                </div>
                            </div>
                            <div className="mt-8 flex flex-col">
                                <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                    <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                                        <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg">
                                            <table className="min-w-full table-fixed divide-y divide-gray-300">
                                                <thead>
                                                    <tr>
                                                     
                                                        <th scope="col" className="min-w-[8rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-600">
                                                            Account Number
                                                        </th>
                                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-600">
                                                            Name on Card
                                                        </th>
                                                        <th scope="col" className="min-w-[8rem]  px-3 py-3.5 text-left text-sm italic font-normal text-gray-600">
                                                            Account Officer
                                                        </th>
                                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-600">
                                                            Branch
                                                        </th>
                                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-600">
                                                            Date Issued
                                                        </th>
                                                        <th scope="col" className="min-w-[6rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-600">
                                                            Card Type
                                                        </th>
                                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-600">
                                                            Status
                                                        </th>
                                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-600">

                                                        </th>
                                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                            <span className="sr-only">Edit</span>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody className="divide-y divide-gray-200 bg-white">
                                                    {people.map((person) => (
                                                        <tr key={person.email} className="bg-gray-50">                                                         
                                                            <td  className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.accounNo} </td>
                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.cardName}</td>
                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.accounOfficer}</td>
                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.branch}</td>
                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.date}</td>
                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.cardType}</td>
                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.status}</td>
                                                            <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                                                <Link to=" " className="text-gray-600 ">
                                                                    <DotsHorizontalIcon /> <span className="sr-only">, {person.cardName}</span>
                                                                </Link>

                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </React.Fragment>
        </Layout></>)
}